module.exports = __webpack_public_path__ + "static/media/armazemrio.3d50507c.webp";